export default {
  SET_IMPORT_RECORDS(state, data) {
    const idSet = new Set(state.importHistory.map((obj) => obj.id));

    for (const obj of data) {
      if (!idSet.has(obj.id)) {
        state.importHistory.push(obj);
        idSet.add(obj.id);
      }
    }
  },
};
